import { createStore } from 'vuex'
import createPersistedstate from 'vuex-persistedstate'
import session from './modules/session'
import company from './modules/company'
export default createStore({
  modules: {
    session,
    company
  },
  plugins: [
    createPersistedstate({
      key: 'mygct_wechat_approve'
    })
  ]
})
